<template>
  <vvs-select
    :name="name"
    :label="label"
    :validate="validate"
    :options="$store.getters['addresses/getCounties']"
    :disabled="$store.getters['addresses/getCounties'].length === 0"
    :loading="loader"
    v-model="proxy"
    @change="onChange"
    @input="onInput"
    :return-object="returnObject"
    :normal-label="normalLabel"
  ></vvs-select>
</template>

<script>
import formControlMixin from '@/mixins/form.control.mixin';

export default {
  name: 'SelectCounty',
  mixins: [formControlMixin],
  props: {
    city: {
      type: Object,
      default: null,
    },
  },
  methods: {
    async getCounties() {
      await this.$store.commit('addresses/setCounties', {});

      if (this.city) {
        this.loader = true;
        await this.$store.dispatch('addresses/fetchCounties', {
          cityId: this.city.id,
        });
        this.loader = false;
      }
    },
  },
  watch: {
    city() {
      this.getCounties();
    },
  },
  async mounted() {
    await this.getCounties();
  },
};
</script>
